import { useAuth0 } from '@auth0/auth0-react';
import CircularProgress from '@mui/material/CircularProgress';
import * as React from 'react';
import { useEffect } from 'react';
import { Route, RouteProps } from 'react-router';
import { observer } from 'mobx-react';
import AccessDenied from '../error/AccessDenied';
import { useStore } from '../../store/store';
import { ECreatorUserRole } from '../../store/user/userStore';
import IncorrectRole from '../../routes/auth/IncorrectRole';
import Login from '../../routes/auth/Login';
import NoAccess from '../../routes/auth/NoAccess';

interface IProtectedRouteProps extends RouteProps {
  requiredRole?: ECreatorUserRole;
}

export default observer(function ProtectedRoute({ requiredRole = ECreatorUserRole.trial, ...props }: IProtectedRouteProps) {
  const { userStore } = useStore();
  const { role, user } = userStore;
  const { isLoading, loginWithRedirect, isAuthenticated: isAuth0Authenticated, error } = useAuth0();

  if (isLoading) {
    return (
      <div style={{ flex: '1 1 auto', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress />
      </div>
    );
  }

  if (error && !isLoading) {
    if (error.message === 'Unauthorized Account.' || error.message === 'Validate Email.') {
      return <AccessDenied error={error} />;
    }
  }

  if (isAuth0Authenticated && !isLoading) {
    if (user === undefined) {
      return <Login />;
    } else if (role >= requiredRole) {
      return <Route {...props} />;
    } else if (role < requiredRole) {
      return <NoAccess />;
    } else {
      return <IncorrectRole />;
    }
  }

  loginWithRedirect();
  return <></>;
});
